module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-06.c4c93301.png";